import Loadable from 'UIComponents/decorators/Loadable';
import AsyncBatchThreadOperationsToolbarContainerError from './AsyncBatchThreadOperationsToolbarContainerError';
import EmptyComponent from './EmptyComponent';
const AsyncBatchSearchOperationsToolbarContainer = Loadable({
  loader: () => import( /* webpackChunkName: "batch-thread-operations-container" */'../../batch-thread-operations-toolbar/containers/BatchSearchOperationsToolbarContainer'),
  LoadingComponent: EmptyComponent,
  ErrorComponent: AsyncBatchThreadOperationsToolbarContainerError
});
export default AsyncBatchSearchOperationsToolbarContainer;